import SettingsInputTable from './settings-input-table';

export default SettingsInputTable;
